export default __webpack_public_path__ + "static/media/iq-img1.81341147.png";